import { Button, Form, Input } from "antd"
import { User } from "@types";
import { useEffect } from "react";
import { useAddParticipant, useEditParticipant } from "@hooks";
import { PlusCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
    participant?: User;
}

export const ParticipantForm = ({participant}: Props) => {

    const [form] = Form.useForm();
    const {t} = useTranslation();
    const addParticipant = useAddParticipant();
    const editParticipant = useEditParticipant();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (participant) {
            form.setFieldsValue(participant);
        }
    }, [participant])

    const onFinish = (values: any) => {
        if (participant) {
            editParticipant.mutate({
                ...participant,
                ...values   
            }, {
                onSuccess() {
                    queryClient.invalidateQueries({ queryKey: ["examPeriods"] });
                }
            });
        } else {
            addParticipant.mutate(values, {
                onSuccess() {
                    form.resetFields();
                }
            });
        }
    }

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
             <Form.Item name={["oib"]} label={"Oib"}>
                <Input />
              </Form.Item>
              <Form.Item name={["firstName"]} label={t("pages.examPeriods.applicantsTab.userName")}>
                <Input />
              </Form.Item>
              <Form.Item name={["lastName"]} label={t("pages.examPeriods.applicantsTab.lastName")}>
                <Input />
              </Form.Item>
              <Form.Item name={["email"]} label={t("pages.examPeriods.applicantsTab.email")}>
                <Input />
              </Form.Item>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={addParticipant.isPending} icon={<PlusCircle />}>
                {t("pages.examPeriods.applicantsTab.addToList")}
                </Button>
              </div>
        </Form>
    )
}